/**
 * [INPUT]: 依赖 PolarRoot 结构根与 PieCanvas 切片绘制器
 * [OUTPUT]: 对外提供 PieChart/Donut 组合根
 * [POS]: dither-kit 单 series 极坐标占比图入口
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
"use client";
import { PieCanvas } from "./pie-canvas"
import { PolarRoot } from "./polar-root"

/** Composable dither **pie / donut** chart. Compose `<Pie>`, `<Legend>`, … inside. */
export function PieChart(props) {
  return <PolarRoot chartType="pie" Canvas={PieCanvas} {...props} />;
}
